module.exports = __webpack_public_path__ + "img/nav-note.405e29c7.svg";